import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { DateProvider } from '../../../providers';
import FONT_FAMILY from '../../../constants/fontFamily';
import FontFamilyHeader from '../../FontFamilyHeader';
import LogoPremierLeague from './logo.svg';
import {
  Container,
  Header,
  Logo,
  PointsAway,
  PointsHome,
  TeamBackgroundAway,
  TeamBackgroundHome,
  TeamContainerAway,
  TeamContainerHome,
  TeamName,
  Timer,
  TimerContainer,
} from './styles';

function SoccerPremierLeague2024({ data }) {
  const { awayTeam, homeTeam, status, time } = data;
  const [, refresh] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => refresh(Date.now()), 1000);
    if (status === 'paused') clearInterval(interval);
    return () => {
      clearInterval(interval);
    };
  }, [status]);

  const getTime = () => {
    if (time.length === 0) return '00:00';
    const [minutes, seconds] = DateProvider.getSoccerTime(time);
    return `${minutes}:${seconds}`;
  };

  return (
    <>
      <FontFamilyHeader family={FONT_FAMILY['premierLeague']} />
      <Container>
        <Header>
          <TeamContainerHome
            style={{ background: homeTeam?.colors?.[0]?.value }}
          >
            <TeamName style={{ color: homeTeam?.colors?.[2]?.value }}>
              {homeTeam.name}
            </TeamName>
            <PointsHome>{homeTeam.points}</PointsHome>
            <TeamBackgroundHome
              xmlns="http://www.w3.org/2000/svg"
              width="55"
              height="48"
              viewBox="0 0 55 48"
              fill="none"
            >
              <path
                d="M55 0H0L24.6053 24.3636H0L28.9474 48L55 0Z"
                fill="url(#paint0_linear_2607_51)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_2607_51"
                  x1="6"
                  y1="7.0408e-07"
                  x2="43"
                  y2="27.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color={homeTeam?.colors?.[1]?.value} />
                  <stop
                    offset="1"
                    stop-color={homeTeam?.colors?.[1]?.value}
                    stop-opacity="0"
                  />
                </linearGradient>
              </defs>
            </TeamBackgroundHome>
          </TeamContainerHome>
          <Logo alt="Logo Premier League" src={LogoPremierLeague} />
          <TeamContainerAway
            style={{ background: awayTeam?.colors?.[0]?.value }}
          >
            <TeamBackgroundAway
              xmlns="http://www.w3.org/2000/svg"
              width="55"
              height="48"
              viewBox="0 0 55 48"
              fill="none"
            >
              <path
                d="M0 48L55 48L30.3947 23.6364L55 23.6364L26.0526 0L0 48Z"
                fill="url(#paint0_linear_2607_52)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_2607_52"
                  x1="49"
                  y1="48"
                  x2="13.5"
                  y2="20.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color={awayTeam?.colors?.[1]?.value} />
                  <stop
                    offset="1"
                    stop-color={awayTeam?.colors?.[1]?.value}
                    stop-opacity="0"
                  />
                </linearGradient>
              </defs>
            </TeamBackgroundAway>
            <PointsAway>{awayTeam.points}</PointsAway>
            <TeamName style={{ color: awayTeam?.colors?.[2]?.value }}>
              {awayTeam.name}
            </TeamName>
          </TeamContainerAway>
        </Header>
        <TimerContainer>
          <Timer>{getTime()}</Timer>
        </TimerContainer>
      </Container>
    </>
  );
}

SoccerPremierLeague2024.propTypes = {
  data: PropTypes.shape({
    awayTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    homeTeam: PropTypes.shape({
      colors: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          value: PropTypes.string,
        })
      ),
      image: PropTypes.string,
      name: PropTypes.string,
      points: PropTypes.number,
    }),
    status: PropTypes.string,
    time: PropTypes.arrayOf(PropTypes.number),
  }),
  styles: PropTypes.shape({}),
};

SoccerPremierLeague2024.defaultProps = {
  data: {
    awayTeam: {
      colors: [
        { id: 1, value: '#ECFC2B' },
        { id: 2, value: '#000000' },
        { id: 3, value: '#000000' },
      ],
      name: 'ARS',
      points: 0,
    },
    homeTeam: {
      colors: [
        { id: 1, value: '#0E0A92' },
        { id: 2, value: '#8D0F25' },
        { id: 3, value: '#FFFFFF' },
      ],
      name: 'CRY',
      points: 0,
    },
    status: 'paused',
    time: [],
  },
  styles: {},
};

export default SoccerPremierLeague2024;
